import { render, staticRenderFns } from "./FakeRetrievalQueryCard.vue?vue&type=template&id=52c16ace&"
import script from "./FakeRetrievalQueryCard.vue?vue&type=script&lang=ts&"
export * from "./FakeRetrievalQueryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports